import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { DatePickerWebElement } from './DatePickerWebElement';
export { DatePickerWebElement };

/**
 * Retrieve an instance of [DatePickerWebElement](../classes/DatePickerWebElement.html).
 * @example
 * ```javascript
 * import { findDatePicker } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findDatePicker(driver, By.id('my-oj-c-date-picker'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findDatePicker(driver: DriverLike, by: By): Promise<DatePickerWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type DatePickerWebElement
  if (!(webEl instanceof DatePickerWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'DatePickerWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findDatePicker(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${DatePickerWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-date-picker', DatePickerWebElement);
